export default __webpack_public_path__ + "static/media/support-notes-logo-co.51762342.svg";